import { defineComponent as _defineComponent } from 'vue'
import GBaseModal from '@/components/g-base-modal.vue'
import store from '@/store'
import { translate } from '@/util/commonFun'
import { folderIsExist } from '@/util/fileSystem'
import {
  checkCurrentUseFolder,
  storageLocalFolder,
} from '@/util/fileSystem/generateFile'
import { message } from 'ant-design-vue'
import { ref } from 'vue'

/**
 * 弹窗需要一个回调函数，具体使用需要引入组件且调用组件的验证方法，当验证通过时或选择其他方式下载
 * 都会调用回调函数(我好像想不到其他更好的方法了，有大佬有其他好的方法，建议替换这种方式)
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'g-folder-choose-modal',
  props: {
    cb: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  cb?: (...args: any) => any
}



const isShow = ref(false)

/** 跳过检查在重新检查的时候才会进行重置所以需要外部一定要再次调用检查函数 */
const isSkipCheckFolder = ref(false)
const currentUseFolder = ref<any>(null)

function ct(k: string, val?: any) {
  return translate('common.' + k, val)
}
function t(k: string, val?: any) {
  return translate('arrangedPage.' + k, val)
}

/** 检查nc下载需要使用的本地目录是否还存在 */
async function verify(preferencesSetting?: any) {
  preferencesSetting =
    preferencesSetting || store.state?.preferencesSetting?.setting
  // 用户选择用zip导出则不做处理
  if (!preferencesSetting?.is_use_folder_export) {
    return true
  }
  if (isSkipCheckFolder.value) {
    // 判断完成之后则将数据重置
    isSkipCheckFolder.value = false
    return true
  }
  // 在此处选择一个文件位置来存储前端直接生成文件夹的位置，如果浏览器不适配则此方法无效
  const data = await checkCurrentUseFolder()
  // data不存在数据则说明当前使用的浏览器不支持这种导出方式
  if (!data) {
    return true
  }
  // 用户未授权
  if (!data.permission) {
    return true
  }
  currentUseFolder.value = data
  const { handle } = data
  // 检查当前句柄的文件夹是否存在
  const isExist = await folderIsExist(handle)

  if (isExist && handle) {
    return true
  } else {
    isShow.value = true
  }
}
/** 重新选择目录 */
async function handleReSelectFolder() {
  try {
    isShow.value = false
    const { permission } = (await storageLocalFolder()) ?? {}
    if (!permission) {
      message.warning(translate('fileManagerPage.notOpeFolderPermission'))
    }
    props.cb && props.cb()
  } catch (error) {
    isShow.value = true
  }
}
/** 直接去下载zip */
async function handleDownloadZip(data: any) {
  const { cancelType } = data
  if (cancelType === 'button') {
    isSkipCheckFolder.value = true
    props.cb && props.cb()
  }
  isShow.value = false
}

expose({
  verify,
})

return { __sfc: true,props, isShow, isSkipCheckFolder, currentUseFolder, ct, t, verify, handleReSelectFolder, handleDownloadZip, GBaseModal }
}

})